export const SUPPLIER_INFO_QUERY = '/supplier';
export const SUPPLIER_ASSESSMENT_REMEDIATIONS_QUERY = '/supplier/:id/assessment/remediations';
export const SUPPLIER_ASSESSMENT_ANSWERS_QUERY = '/supplier/:id/assessment/answers';
export const SUPPLIER_ASSESSMENT_SCOPING_ANSWERS_QUERY = '/supplier/:id/assessment/answers/scoping';
export const SUPPLIER_ASSESSMENT_NOTES_QUERY = '/supplier/:id/assessment/client-answer-notes';
export const SUPPLIER_ASSESSMENT_OVERRIDES_QUERY = '/supplier/:id/assessment/overrides';
export const SUPPLIER_REASSESSMENT_STATUS_QUERY = '/reassessment/status';
export const SUPPLIER_COMMUNITY_SIGNALS_QUERY = '/suppliers/:id/community-signals';
export const SUPPLIER_COMPLIANCE_VTWO_QUERY = '/supplier/:id/compliance/v2';
export const SUPPLIER_EVIDENCE_QUERY = '/supplier/:id/evidences';
export const CLIENT_INFO_QUERY = '/client';
export const CLIENT_ASSESSMENT_REMEDIATIONS_QUERY = '/client/:id/assessment/remediations';
export const CLIENT_ASSESSMENT_ANSWERS_QUERY = '/client/:id/assessment/answers';
export const CLIENT_ASSESSMENT_SCOPING_ANSWERS_QUERY = '/client/:id/assessment/answers/scoping';
export const CLIENT_ASSESSMENT_OVERRIDES_QUERY = '/client/:id/assessment/overrides';
export const CLIENT_COMPLIANCE_VTWO_QUERY = '/client/:id/compliance/v2';
export const SUPPLIER_PUBLIC_INFO_QUERY = '/supplier/info';
export const SUPPLIER_PROFILE_SUMMARY_QUERY = '/suppliers/:id/profile-summary';
export const SUPPLIER_ASSESSMENT_REVIEW_QUERY = '/suppliers/:id/assessment-review';
